export const data = [
  {
    id: "1",
    content: "Complete online JavaScript course",
    completed: true,
  },
  {
    id: "2",
    content: "Jog around the park 3x",
    completed: false,
  },
  {
    id: "3",
    content: "10 minutes meditation",
    completed: true,
  },
  {
    id: "4",
    content: "Read for 1 hour",
    completed: false,
  },
  {
    id: "5",
    content: "Pick up groceries",
    completed: false,
  },
  {
    id: "6",
    content: "Complete Todo App on Frontend Mentor",
    completed: true,
  },
];
